export default __webpack_public_path__ + "static/media/Untitled_Artwork-4.0cdc68be.png";